// extracted by mini-css-extract-plugin
module.exports = {"name":"formatters_name__3cu9K","totalPrice":"formatters_totalPrice__1iRYb"};